import { render, staticRenderFns } from "./TotalAnalogCloseRatioIcon.vue?vue&type=template&id=2bd4e33e&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports